import type { BasketOptimizerResultRow, UnderlyingTag } from 'state/advisory/basket-optimizer/model';

export type BasketOptimizerAction =
  | BasketOptimizerCouponFromChanged
  | BasketOptimizerCouponToChanged
  | BasketOptimizerIsMutuallyExclusiveToggled
  | BasketOptimizerOptimizeCanceled
  | BasketOptimizerOptimizeIdReceived
  | BasketOptimizerOptimizeRequestFailed
  | BasketOptimizerResultReceived
  | BasketOptimizerUnderlyingTagsChanged
  | BasketOptimizerTargetBasketSizeChanged
  | BasketOptimizerOptimizeRequested;

/////////////////////////////////////////////
export interface BasketOptimizerIsMutuallyExclusiveToggled {
  type: 'BASKETOPTIMIZER_IS_MUTUALLY_EXCLUSIVE_TOGGLED';
  tabId: string;
}
export function basketOptimizerIsMutuallyExclusiveToggled(tabId: string): BasketOptimizerIsMutuallyExclusiveToggled {
  return {
    type: 'BASKETOPTIMIZER_IS_MUTUALLY_EXCLUSIVE_TOGGLED',
    tabId,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerCouponFromChanged {
  type: 'BASKETOPTIMIZER_COUPON_FROM_CHANGED';
  tabId: string;
  value?: number;
}
export function basketOptimizerCouponFromChanged(tabId: string, value?: number): BasketOptimizerCouponFromChanged {
  return {
    type: 'BASKETOPTIMIZER_COUPON_FROM_CHANGED',
    tabId,
    value,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerTargetBasketSizeChanged {
  type: 'BASKETOPTIMIZER_TARGET_BASKET_SIZE_CHANGED';
  tabId: string;
  value: number | undefined;
}

export function basketOptimizerTargetBasketSizeChanged(
  tabId: string,
  value?: number,
): BasketOptimizerTargetBasketSizeChanged {
  return {
    type: 'BASKETOPTIMIZER_TARGET_BASKET_SIZE_CHANGED',
    tabId,
    value,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerCouponToChanged {
  type: 'BASKETOPTIMIZER_COUPON_TO_CHANGED';
  tabId: string;
  value?: number;
}
export function basketOptimizerCouponToChanged(tabId: string, value?: number): BasketOptimizerCouponToChanged {
  return {
    type: 'BASKETOPTIMIZER_COUPON_TO_CHANGED',
    tabId,
    value,
  };
}

////////////////////////////////////////////

///////////////////////////////////////////// - Optimization requested
export interface BasketOptimizerOptimizeRequested {
  type: 'BASKETOPTIMIZER_OPTIMIZE_REQUESTED';
  tabId: string;
  quoteId: string;
  productType: string;
  underlyingsCount: number;
}

export function basketOptimizerOptimizeRequested(
  tabId: string,
  quoteId: string,
  productType: string,
  underlyingsCount: number,
): BasketOptimizerOptimizeRequested {
  return {
    type: 'BASKETOPTIMIZER_OPTIMIZE_REQUESTED',
    tabId,
    quoteId,
    productType,
    underlyingsCount,
  };
}

/////////////////////////////////////////////  - Optimization canceled
export interface BasketOptimizerOptimizeCanceled {
  type: 'BASKETOPTIMIZER_OPTIMIZE_CANCELED';
  tabId: string;
  optimizeId: string;
}
export function basketOptimizerOptimizeCanceled(tabId: string, optimizeId: string): BasketOptimizerOptimizeCanceled {
  return {
    type: 'BASKETOPTIMIZER_OPTIMIZE_CANCELED',
    tabId,
    optimizeId,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerOptimizeIdReceived {
  type: 'BASKETOPTIMIZER_OPTIMIZE_ID_RECEIVED';
  tabId: string;
  quoteId: string;
  optimizeId: string;
  estimatedComputationTimeInSeconds: number;
}
export function basketOptimizerOptimizeIdReceived(
  tabId: string,
  quoteId: string,
  optimizeId: string,
  estimatedComputationTimeInSeconds: number,
): BasketOptimizerOptimizeIdReceived {
  return {
    type: 'BASKETOPTIMIZER_OPTIMIZE_ID_RECEIVED',
    tabId,
    quoteId,
    optimizeId,
    estimatedComputationTimeInSeconds,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerResultReceived {
  type: 'BASKETOPTIMIZER_RESULT_RECEIVED';
  tabId: string;
  result: BasketOptimizerResultRow[];
}
export function basketOptimizerResultReceived(
  tabId: string,
  result: BasketOptimizerResultRow[],
): BasketOptimizerResultReceived {
  return {
    type: 'BASKETOPTIMIZER_RESULT_RECEIVED',
    tabId,
    result,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerOptimizeRequestFailed {
  type: 'BASKETOPTIMIZER_OPTIMIZE_REQUEST_FAILED';
  tabId: string;
  errorMessage: string;
}
export function basketOptimizerOptimizeRequestFailed(
  tabId: string,
  errorMessage: string,
): BasketOptimizerOptimizeRequestFailed {
  return {
    type: 'BASKETOPTIMIZER_OPTIMIZE_REQUEST_FAILED',
    tabId,
    errorMessage,
  };
}

/////////////////////////////////////////////
export interface BasketOptimizerUnderlyingTagsChanged {
  type: 'BASKET_OPTIMIZER_UNDERLYING_TAGS_CHANGED';
  tabId: string;
  tags: UnderlyingTag[];
}
export function basketOptimizerUnderlyingTagsChanged(
  tabId: string,
  tags: UnderlyingTag[],
): BasketOptimizerUnderlyingTagsChanged {
  return {
    type: 'BASKET_OPTIMIZER_UNDERLYING_TAGS_CHANGED',
    tabId,
    tags,
  };
}
